import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { SelectItemFieldPipe } from './select-item-field.pipe';

type SelectItem = string | number | Record<string, unknown>;

@Component({
  selector: 'ui-select-mini',
  templateUrl: './select-mini.component.html',
  styleUrls: ['./select-mini.component.scss'],
  imports: [NzIconModule, SelectItemFieldPipe],
  providers: [SelectItemFieldPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.width]': 'width()',
    '(document:click)': 'handleClickOutside($event)',
  },
})
export class UISelectMini {
  // Inputs
  list = input<SelectItem[]>([]);
  displayField = input<string>();
  valueField = input<string>();
  value = input<unknown>();
  width = input<string>('100px');

  // Outputs
  valueChange = output<unknown>();

  // View child
  selectTplRef = viewChild<ElementRef>('dropDownEl');

  // State
  isExpanded = signal(false);
  selectedItemIndex = signal(0);

  // Computed
  selectedValue = computed(() => {
    const items = this.list();
    const currentValue = this.value();

    const index = items.findIndex(item => {
      return this.selectItemFieldPipe.transform(item, this.valueField()) === currentValue;
    });

    return index !== -1 ? index : 0;
  });

  private elementRef = inject(ElementRef);
  private selectItemFieldPipe = inject(SelectItemFieldPipe);

  constructor() {
    // Update selected index when value changes
    effect(() => {
      this.selectedItemIndex.set(this.selectedValue());
    });
  }

  // Закрыть при клике вне компонента
  handleClickOutside(event: MouseEvent): void {
    const selectRef = this.selectTplRef();
    if (selectRef && !this.elementRef?.nativeElement?.contains(event.target)) {
      this.isExpanded.set(false);
    }
  }

  onClick(): void {
    this.isExpanded.update(expanded => !expanded);
  }

  onSelectItem(itemIndex: number): void {
    const items = this.list();
    const item = items[itemIndex];
    const selectedValue = this.selectItemFieldPipe.transform(item, this.valueField());

    this.selectedItemIndex.set(itemIndex);
    this.valueChange.emit(selectedValue);
  }
}
